import React from "react";
import { Box, Card, Typography } from "@mui/material";
import workshopImage from "../../../images/backdrop.png";
import style from "./SelectWorkshop.module.css";
import { version } from "../../../version";

const SelectWorkshop = () => {
  return (
    <Box
      sx={{
        position: "relative",
        bgcolor: "background.main",
        backgroundImage: `url(${workshopImage})`,
      }}
      className={style.selectWorkshop}
    >
      <Typography variant="h1" textAlign="center" sx={{ fontWeight: "500" }}>
        Please Select A Workshop
      </Typography>
      <Typography
        variant="body1"
        sx={{
          position: "absolute",
          bottom: "0.5rem",
          right: "0.5rem",
          color: "#96aac1",
        }}
      >
        v{version}
      </Typography>
    </Box>
  );
};

export default SelectWorkshop;
